import { Link } from 'react-router-dom';
import bandjerryLogo from '@/images/bandjerry_logo.svg';

export default function PublicHeader() {
  return (
    <header className="absolute top-0 left-0 right-0 z-50 flex items-center justify-between px-6 py-5 md:px-10">
      <Link to="/" className="flex items-center gap-2 text-[26px] font-bold text-white no-underline">
        <img src={bandjerryLogo} alt="BandJerry logo" className="h-[1.5em] w-auto" />
        <span>BAND<span className="text-primary-600">JERRY</span></span>
      </Link>
      <nav className="flex items-center gap-3">
        <Link
          to="/login"
          className="inline-block rounded bg-primary-600 px-6 py-2.5 text-sm font-bold text-black no-underline transition-colors hover:bg-primary-500"
        >
          Sign In
        </Link>
        <Link
          to="/tutorials"
          className="hidden rounded border-2 border-primary-600 px-6 py-2 text-sm font-bold text-primary-600 no-underline transition-colors hover:bg-primary-600 hover:text-black md:inline-block"
        >
          Tutorials
        </Link>
      </nav>
    </header>
  );
}
